<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                USUÁRIO -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label for="login">Login</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="login"
                                    placeholder="Digite o login do usuário no AD"
                                    v-model="usuarioDto.login"
                                    @input.native="$v.usuarioDto.login.$touch()"
                                    :state="
                                        $v.usuarioDto.login.$error
                                            ? false
                                            : null
                                    "
                                    v-mask="'XXXXXXXXXX'"
                                    :disabled="loginAdValido"
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button
                                        variant="primary"
                                        @click="pesquisarLoginAd()"
                                        title="Clique para pesquisar o usuário no AD"
                                        v-if="!loginAdValido"
                                    >
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                    <b-button
                                        v-if="loginAdValido"
                                        variant="warning"
                                        @click="confirmarModificarLogin()"
                                        title="Clique para modificar o login digitado"
                                    >
                                        <i class="fa fa-eraser"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-invalid-feedback
                                >O login do usuário no AD é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="5">
                        <b-form-group>
                            <label for="nome">Nome</label>
                            <b-form-input
                                type="text"
                                id="nome"
                                placeholder="Digite o nome do usuário"
                                v-model="usuarioDto.nome"
                                :disabled="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label for="email">e-mail</label>
                            <b-form-input
                                type="text"
                                id="email"
                                placeholder="Digite o e-mail da instituição"
                                v-model="usuarioDto.email"
                                :disabled="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label for="contato">Observações</label>
                            <b-form-textarea
                                id="observacoes"
                                v-model="usuarioDto.observacoes"
                                :rows="4"
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>-->
            </div>
            <!-- {{ $v }} -->
        </b-card-body>
        <b-card-footer>
            <b-button
                variant="primary"
                @click.stop="salvarForm()"
                :disabled="!habilitarSalvar"
                class="mr-2"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
            <b-button variant="danger" @click.stop="cancelar()" class="mr-2">
                <span> <i class="fa fa-remove"></i> Cancelar </span>
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import UsuariosServicos from './UsuariosServicos'

export default {
    data() {
        return {
            erros: [],
            usuarioDto: {
                login: '',
                nome: '',
                email: '',
                observacoes: ''
            },
            operacao: 'INSERIR',
            loginAdValido: false
        }
    },

    methods: {
        salvarForm() {
            let usuario = {
                nome: this.usuarioDto.nome.toUpperCase(),
                login: this.usuarioDto.login.toLowerCase(),
                email: this.usuarioDto.email.toLowerCase(),
                observacoes: this.usuarioDto.observacoes
            }
            this.inserirUsuario(usuario)
        },

        cancelar() {
            this.erros = []
            this.$router.push({ name: 'Usuarios' })
        },

        inserirUsuario(usuario) {
            this.$store.dispatch('addRequest')
            UsuariosServicos.inserirUsuario(usuario).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso(response.data)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        pesquisarLoginAd() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.pesquisarLoginAd(this.usuarioDto.login).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.preencheFormulario(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso(usuarioId) {
            this.erros = []
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$store.dispatch('setRecarregar', true)
            this.$router.push({
                name: 'Usuarios_Detalhar',
                params: { usuarioId: usuarioId }
            })
        },

        preencheFormulario(data) {
            if (data) {
                this.usuarioDto.nome = data.nome.toUpperCase()
                this.usuarioDto.email = data.email
                this.loginAdValido = true
            }
        },

        confirmarModificarLogin() {
            this.$swal({
                title: 'Modificar Login',
                html: `Confirma modificação do campo Login?<br>Essa ação limpará todo o formulário!!!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.limparFormulario()
                }
            })
        },

        limparFormulario() {
            this.usuarioDto.nome = ''
            this.usuarioDto.login = ''
            this.usuarioDto.email = ''
            this.loginAdValido = false
        }
    },

    computed: {
        habilitarSalvar() {
            return !this.$v.$invalid
        }
    },

    validations: {
        usuarioDto: {
            nome: {
                required
            },
            login: {
                required
            },
            email: {
                required,
                email
            }
        }
    }
}
</script>
